import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import clsx from 'clsx';
import Thumbnail from "./Thumbnail";

export default function ThumbnailSection({
  images, selectedImage, columns = 2, callbacks, className, productGroup, ...props
}) {
  // Thumbnail section: main images and videos. 2 columns on desktop.
  // On mobile, not a grid, images will just space themselves in one row
  // with inline-block and margin.
  className = clsx(className, "inline-block md:grid auto-rows-fr",
    `md:grid-cols-${columns}`);

  return <div className={className}>
    {images.map((img, i) => <Thumbnail key={i} image={img}
      selectedImage={selectedImage}
      productGroup={productGroup}
      callbacks={callbacks}/>)}
  </div>;
}
